// List of IDs that correspond to the department id as they are in Polopoly (keep in alphabetical order).
// If ending in {section}/swimlane, it corresponds to the department ID of the swimlane located on {section}.
// prettier-ignore
const LINEUP_SLUGS={
    2017: "2017",
    "2017/becoming-canadian": "2017-becoming-canadian",
    "2017/canada-a-peoples-history": "2017-canada-a-peoples-history",
    "2017/canadais": "2017-canada-is",
    "2017/canadathestoryofus": "2017-canada-the-story-of-us",
    "2017/canadathestoryofus/csou-episodes": "2017-canada-the-story-of-us-episodes",
    "2017/nye": "2017-nye",
    "2017/truenorthcalling": "2017-true-north-calling",
    "2017/we-are-the-best": "2017-we-are-the-best",
    "2017/wearecanada": "2017-we-are-canada",
    "2017/whatsyourstory": "2017-whats-your-story",
    "2017/wild-canadian-year": "2017-wild-canadian-year",
    archives: "archives",
    "archives/arts": "archives-arts-entertainment",
    "archives/history": "archives-history",
    "archives/sports": "archives-sports",
    arts: "arts",
    "arts/watch": "arts-watch",
    "arts/read": "arts-read",
    "arts/canada-in-the-frame": "arts-canada-in-the-frame",
    "arts/canadianscreenawards": "arts-canadian-screen-awards",
    "arts/insurgenceresurgence": "arts-insurgence-resurgence",
    "arts/crashgallery": "arts-crash-gallery",
    "arts/disruptingdesign": "arts-disrupting-design",
    "arts/eddyrogo": "arts-the-re-education-of-eddy-rogo",
    "arts/exhibitionists": "arts-exhibitionists",
    "arts/interruptthisprogram": "arts-interrupt-this-program",
    "arts/inthemaking": "in-the-making",
    "arts/secretpath": "arts-secret-path",
    "arts/thecollective": "arts-the-collective",
    "arts/thefilmmakers": "arts-the-filmmakers",
    "arts/arts-watch-on-gem": "arts-watch-on-gem",
    "arts/artuncontained": "arts",
    books: "books",
    "books/canadareads": "books-canada-reads",
    "books/literaryprizes": "books-literary-prizes",
    "books/canadawrites": "books-canada-writes",
    "books/readinglists": "books-reading-lists",
    "books/ggbooks": "books-governor-generals-literary-awards",
    "books/gillerprize": "books-giller-prize",
    "books/kids": "books-presented-by-td",
    "books/transmission": "books-transmission",
    cape: "cape", // CBC AbiliCrew Placements for Exellence Program
    comedy: "comedy",
    "comedy/instagram": "comedy-instagram",
    cree: "cree",
    documentaries: "documentaries",
    "documentaries/specials": "docs-specials",
    "documentaries/features": "docs-features-swimlane",
    "documentaries/brief-but-spectacular": "brief-but-spectacular",
    "documentaries/the-oland-murder": "the-oland-murder",
    "documentaries/hotdocsoncbc": "docs-hot-docs-at-home",
    "documentaries/goodpeople": "docs-good-people",
    "documentaries/enslaved": "docs-enslaved",
    homepage: "homepage",
    "homepage/featured": "homepage-featured",
    "homepage/gem": "homepage-gem",
    "homepage/paralympics": "sports-paralympics",
    indspire: "indspire",
    "learning-english": "learning-english",
    "learning-english/level-1": "learning-english-level-1",
    "learning-english/level-2": "learning-english-level-2",
    "learning-english/past-lessons": "learning-english-past-lessons",
    "learning-english/past-lessons/calgary": "learning-english-past-lessons-calgary",
    "learning-english/past-lessons/edmonton": "learning-english-past-lessons-edmonton",
    life: "life",
    "life/culture": "life-culture",
    "life/food": "life-food",
    "life/giveaways": "life-giveaways",
    "life/backintimefordinner": "life-back-in-time-for-dinner",
    "life/backintimefordinner/episodes": "life-back-in-time-for-dinner-episodes",
    "life/greatcanadianbakingshow": "life-great-canadian-baking-show",
    "life/greatcanadianbakingshow/bakers": "life-great-canadian-baking-show-bakers",
    "life/greatcanadianbakingshow/recipes": "life-great-canadian-baking-show-recipes",
    "life/greatcanadianbakingshow/about": "life-great-canadian-baking-show-about",
    "life/jamieoliver": "life-jamie-oliver",
    "life/jamieoliver/recipes": "life-jamie-oliver-recipes",
    "life/jamieoliver/watch": "life-jamie-oliver-watch",
    "life/hellospring": "life-hello-spring",
    "life/hellospring/hellospring-livestream": "life-live-nature-streams",
    "life/hellospring/springscenes": "life-scenes-from-spring",
    "life/hellospring/showusyourspring": "life-show-us-your-spring",
    "life/hellospring/swimlane": "life-hello-spring-swimlane",
    "life/holiday": "life-holiday",
    "life/holiday/cbcgives": "life-holiday-cbc-gives",
    "life/home": "life-home",
    "life/work-money": "life-personal-finance",
    "life/pets": "life-pets",
    "life/style": "life-style",
    "life/thegoods": "life-the-goods",
    "life/getawayguide": "life-getaway-guide",
    "life/travel": "life-travel",
    "life/video": "life-video",
    "life/wellness": "life-wellness",
    "life/fridgewars": "tv-fridge-wars",
    "life/backintimeforwinter": "back-in-time-for-winter",
    "meta/hiddentestpage": "meta-hiddentestpage",
    music: "music-read",
    "music/decadeofdrake": "music-decade-of-drake",
    "music/read/video": "music-read-video",
    "music/firstplaylive": "music-first-play-live",
    "music/events": "music-events",
    "music/events/searchlight": "music-events-searchlight",
    "music/events/festival": "music-events-festival",
    "music/events/canadian-music-class-challenge": "music-events-canadian-music-class-challenge",
    "music/events/polaris": "music-events-polaris",
    "music/events/firstplaylive": "music-first-play-live",
    "music/explore": "music-explore",
    "music/the-intro": "music-the-intro",
    "music/junos": "music-junos",
    "music/junos/watch": "music-junos-watch",
    "music/junos/watch/video": "music-junos-watch-video",
    "music/junos/features": "music-junos-features",
    "music/junos/schedule": "music-junos-schedule",
    "music/junos/news": "music-junos-news",
    "music/junos/sessions": "music-junos-sessions",
    news: "news",
    "news/canada": "news-canada-hybrid",
    "news/canada/british-columbia": "news-canada-british-columbia-hybrid",
    "news/canada/british-columbia/swimlane": "news-canada-bc-headlines",
    "news/canada/british-columbia/community": "news-canada-british-columbia-community",
    "news/canada/british-columbia/video": "news-canada-british-columbia-video",
    "news/canada/new-brunswick/video": "news-canada-new-brunswick-video",
    "news/canada/ottawa/video": "news-canada-ottawa-video",
    "news/canada/manitoba/video": "news-canada-manitoba-video",
    "news/canada/montreal/video": "news-canada-montreal-video",
    "news/canada/saskatchewan/video": "news-canada-saskatchewan-video",
    "news/canada/edmonton/video": "news-canada-edmonton-video",
    "news/canada/newfoundland-labrador/video": "news-canada-newfoundland-labrador-video",
    "news/canada/prince-edward-island/video": "news-canada-prince-edward-island-video",
    "news/canada/thunder-bay/video": "news-canada-thunder-bay-video",
    "news/canada/calgary": "news-canada-calgary-hybrid",
    "news/canada/calgary/video": "news-canada-calgary-video",
    "news/canada/calgary/swimlane": "news-canada-calgary-headlines",
    "news/canada/calgary/community": "news-canada-calgary-community",
    "news/canada/calgary/the-road-ahead": "news-canada-calgary-the-road-ahead",
    "news/canada/edmonton": "news-canada-edmonton-hybrid",
    "news/canada/edmonton/swimlane": "news-canada-edmonton-headlines",
    "news/canada/edmonton/community": "news-canada-edmonton-community",
    "news/canada/hamilton": "news-canada-hamilton-hybrid",
    "news/canada/hamilton/swimlane": "news-canada-hamilton-headlines",
    "news/canada/hamilton/video": "news-canada-hamilton-video",
    "news/canada/kamloops": "news-canada-kamloops",
    "news/canada/kitchener-waterloo": "news-canada-kitchener-waterloo-hybrid",
    "news/canada/kitchener-waterloo/swimlane": "news-canada-kitchener-waterloo-headlines",
    "news/canada/kitchener-waterloo/video": "news-canada-kitchener-waterloo-video",
    "news/canada/london": "news-canada-london-hybrid",
    "news/canada/london/swimlane": "news-canada-london-headlines",
    "news/canada/london/southwestsounds": "news-canada-london-southwest-sounds",
    "news/canada/london/video": "news-canada-london-video",
    "news/canada/manitoba": "news-canada-manitoba-hybrid",
    "news/canada/manitoba/swimlane": "news-canada-manitoba-headlines",
    "news/canada/manitoba/community": "news-canada-manitoba-community",
    "news/canada/montreal": "news-canada-montreal-hybrid",
    "news/canada/montreal/swimlane": "news-canada-montreal-headlines",
    "news/canada/montreal/community": "news-canada-montreal-community",
    "news/canada/montreal/quebecvotes2018": "elections-2018-quebec",
    "news/canada/montreal/quebecvotes2018/swimlane": "quebec-features",
    "news/canada/new-brunswick": "news-canada-new-brunswick-hybrid",
    "news/canada/new-brunswick/swimlane": "news-canada-new-brunswick-headlines",
    "news/canada/new-brunswick/community": "news-canada-new-brunswick-community",
    "news/canada/new-brunswick/nbvotes2018": "elections-2018-new-brunswick",
    "news/canada/new-brunswick/nbvotes2018/swimlane": "new-brunswick-features",
    "news/canada/newfoundland-labrador": "news-canada-newfoundland-labrador-hybrid",
    "news/canada/newfoundland-labrador/swimlane": "news-canada-newfoundland-labrador-headlines",
    "news/canada/newfoundland-labrador/community": "news-canada-newfoundland-labrador-community",
    "news/elections/nlvotes2019": "elections-2019-newfoundland",
    "news/elections/nwtvotes2019": "elections-2019-nwt",
    "news/canada/north": "news-canada-north-hybrid",
    "news/canada/north/swimlane": "news-canada-north-headlines",
    "news/canada/north/community": "news-canada-north-community",
    "news/canada/north/video": "news-canada-north-video-metadata",
    "news/canada/nova-scotia": "news-canada-nova-scotia-hybrid",
    "news/canada/nova-scotia/video": "news-canada-nova-scotia-video",
    "news/canada/nova-scotia/swimlane": "news-canada-nova-scotia-headlines",
    "news/canada/nova-scotia/community": "news-canada-nova-scotia-community",
    "news/canada/ottawa": "news-canada-ottawa-hybrid",
    "news/canada/ottawa/swimlane": "news-canada-ottawa-headlines",
    "news/canada/ottawa/community": "news-canada-ottawa-community",
    "news/canada/prince-edward-island": "news-canada-prince-edward-island-hybrid",
    "news/canada/prince-edward-island/swimlane": "news-canada-pei-headlines",
    "news/canada/prince-edward-island/community": "news-canada-prince-edward-island-community",
    "news/canada/saskatchewan": "news-canada-saskatchewan-hybrid",
    "news/canada/saskatchewan/swimlane": "news-canada-saskatchewan-headlines",
    "news/canada/saskatchewan/community": "news-canada-saskatchewan-community",
    "news/canada/saskatoon": "news-canada-saskatoon-hybrid",
    "news/canada/saskatoon/video": "news-canada-saskatoon-video",
    "news/canada/saskatoon/swimlane": "news-canada-saskatoon-headlines",
    "news/canada/saskatoon/community": "news-canada-saskatoon-community",
    "news/canada/sudbury": "news-canada-sudbury-hybrid",
    "news/canada/sudbury/swimlane": "news-canada-sudbury-headlines",
    "news/canada/sudbury/video": "news-canada-sudbury-video",
    "news/canada/thunder-bay": "news-canada-thunder-bay-hybrid",
    "news/canada/thunder-bay/swimlane": "news-canada-thunder-bay-headlines",
    "news/canada/toronto": "news-canada-toronto-hybrid",
    "news/canada/toronto/swimlane": "news-canada-toronto-headlines",
    "news/canada/toronto/community": "news-canada-toronto-community",
    "news/canada/toronto/video": "news-canada-toronto-video-metadata",
    "news/canada/windsor": "news-canada-windsor-hybrid",
    "news/canada/windsor/video": "news-canada-windsor-video",
    "news/canada/windsor/swimlane": "news-canada-windsor-headlines",
    "news/canada/manitoba/video-test": "news-canada-manitoba-video",
    "news/canada/british-columbia/video-test": "news-canada-british-columbia-video",
    "news/canada/ottawa/video-test": "news-canada-ottawa-video",
    "news/canada/nova-scotia/video-test": "news-canada-nova-scotia-video",
    "news/canada/calgary/video-test": "news-canada-calgary-video",
    "news/canada/new-brunswick/video-test": "news-canada-new-brunswick-video",
    "news/canada/saskatchewan/video-test": "news-canada-saskatchewan-video",
    "news/canada/edmonton/video-test": "news-canada-edmonton-video",
    "news/canada/montreal/video-test": "news-canada-montreal-video",
    "news/canada/newfoundland-labrador/video-test": "news-canada-newfoundland-labrador-video",
    "news/canada/windsor/video-test": "news-canada-southern-ontario-video-metadata",
    "news/canada/toronto/video-test": "news-canada-toronto-video-metadata",
    "news/canada/saskatoon/video-test": "news-canada-saskatoon-video",
    "news/canada/london/video-test": "news-canada-southern-ontario-video-metadata",
    "news/canada/thunder-bay/video-test": "news-canada-northern-ontario-video-metadata",
    "news/canada/prince-edward-island/video-test": "news-canada-prince-edward-island-video-metadata",
    "news/canada/north/video-test": "news-canada-north-video-metadata",
    "news/canada/kitchener-waterloo/video-test": "news-canada-southern-ontario-video-metadata",
    "news/canada/sudbury/video-test": "news-canada-northern-ontario-video-metadata",
    "news/canada/hamilton/video-test": "news-canada-southern-ontario-video-metadata",
    "news/canada/beingblackincanada/all": "being-black-in-canada-hybrid",
    "news/canada/beingblackincanada/gem": "news-canada-beingblackincanada-gem",
    "news/canada/beingblackincanada/archives": "being-black-in-canada-archives",
    "news/covid-19/featured": "news-covid-19-swim-lane",
    "news/covid-19/coping-with-covid-19": "coronavirus-guide",
    "news/editorsblog": "news-editors-blog",
    "news/elections/albertavotes2019": "elections-2019-alberta",
    "news/elections/peivotes2019": "elections-2019-pei",
    "news/elections/topstories": "elections-2019-canada-votes-top",
    "news/elections/utilities": "elections-2019-canada-votes-utilities",
    "news/gopublic": "news-go-public",
    "news/investigates": "news-investigates",
    "news/joandonaldsonscholars": "news-joan-donaldson-scholars",
    "news/opinion": "news-opinion",
    "news/politics/swimlane": "ask-elections-2021",
    "news/politics/powerandpolitics": "news-politics-power-and-politics",
    "news/theinvestigators": "news-the-investigators",
    "news/thenational": "news-the-national",
    "news/theweekly": "news-the-weekly",
    radio: "radio",
    "radio/podcasts": "radio-podcast-feature-lineup",
    "radio/alone": "radio-alone-a-love-story",
    "radio/asithappens": "radio-as-it-happens",
    "radio/becausenews": "radio-because-news",
    "radio/checkup": "radio-checkup",
    "radio/checkup/blog": "radio-checkup-blog",
    "radio/costofliving": "radio-cost-of-living",
    "radio/day6": "radio-day-6",
    "radio/docmakers": "radio-docmakers",
    "radio/docproject": "radio-the-doc-project",
    "radio/findingcleo": "radio-finding-cleo",
    "radio/findingcleo/transcripts": "radio-finding-cleo-transcripts",
    "radio/frontburner": "radio-front-burner",
    "radio/ideas": "radio-ideas",
    "radio/iqpodcast": "radio-inappropriate-questions",
    "radio/iqpodcast/transcripts": "radio-inappropriate-questions-transcripts",
    "radio/laughoutloud": "radio-laugh-out-loud",
    "radio/loveme": "radio-love-me",
    "radio/micdrop": "radio-mic-drop",
    "radio/micdrop/transcripts": "radio-mic-drop-transcripts",
    "radio/nowornever": "radio-now-or-never",
    "radio/ondrugs": "radio-on-drugs",
    "radio/opp": "radio-other-peoples-problems",
    "radio/outintheopen": "radio-out-in-the-open",
    "radio/personalbest": "radio-personal-best",
    "radio/podcastnews": "radio-podcast-news",
    "radio/podcastplaylist": "radio-podcast-playlist",
    "radio/podcastplaylist/blog": "radio-podcast-playlist-blog",
    "radio/q/blog": "radio-q-blog",
    "radio/q/video": "radio-q-video",
    "radio/quirks": "radio-quirks-quarks",
    "radio/quirks/blog": "radio-quirks-quarks-blog",
    "radio/recall": "radio-recall",
    "radio/secretlifeofcanada": "secret-life-of-canada",
    "radio/secretlifeofcanada/transcripts": "radio-secret-life-of-canada-transcripts",
    "radio/sleepover": "radio-sleepover",
    "radio/sks": "radio-someone-knows-something",
    "radio/sks/season1": "radio-someone-knows-something-season-1",
    "radio/sks/season2": "radio-someone-knows-something-season-2",
    "radio/sks/season3": "radio-someone-knows-something-season-3",
    "radio/sks/season4": "radio-someone-knows-something-season-4",
    "radio/sks/season5": "radio-someone-knows-something-season-5",
    "radio/sks/season6": "radio-someone-knows-something", // fetch main page content until ready to create a pubqueue for Season 6
    "radio/sks/transcripts": "radio-someone-knows-something-transcripts",
    "radio/spark": "radio-spark",
    "radio/taiaskswhy": "radio-tai-asks-why",
    "radio/taiaskswhy/teachingguides": "radio-tai-asks-why-teaching-guides",
    "radio/taiaskswhy/transcripts": "radio-tai-asks-why-transcripts",
    "radio/tapestry": "radio-tapestry",
    "radio/thecurrent": "radio-the-current",
    "radio/thedebaters": "radio-the-debaters",
    "radio/thefridgelight": "radio-the-fridge-light",
    "radio/thehouse": "radio-the-house",
    "radio/thenextchapter": "radio-the-next-chapter",
    "radio/thesundayedition": "radio-the-sunday-edition",
    "radio/sunday": "radio-the-sunday-edition",
    "radio/uncover": "radio-uncover",
    "radio/uncover/season1": "radio-uncover-season-1",
    "radio/uncover/season2": "radio-uncover-season-2",
    "radio/uncover/season3": "radio-uncover-season-3",
    "radio/uncover/season4": "radio-uncover-season-4",
    "radio/uncover/season5": "radio-uncover-season-5",
    "radio/uncover/season6": "radio-uncover-season-6",
    "radio/uncover/season7": "radio-uncover-season-7",
    "radio/uncover/season8": "radio-uncover", // fetch main page content until ready to create a pubqueue for current season
    "radio/uncover/transcripts": "radio-uncover-transcripts",
    "radio/undertheinfluence": "radio-under-the-influence",
    "radio/unreserved": "radio-unreserved",
    "radio/whatonearth": "radio-what-on-earth",
    "radio/whitecoat": "radio-white-coat-black-art",
    "radio/whitecoat/blog": "radio-white-coat-black-art-blog",
    "radio/writersandcompany": "radio-writers-and-company",
    "radio/writersandcompany/blog": "radio-writers-and-company-blog",
    reflections: "canadian-reflections",
    sports: "sports",
    "sports/baseball/mlb": "sports-mlb",
    "sports/basketball/nba": "sports-nba",
    "sports/basketball/cebl": "sports-cebl",
    "sports/calgarystampede": "sports-calgary-stampede",
    "sports/calgarystampede/strip": "sports-calgary-stampede-video",
    "sports/canada-150": "sports-canada-150",
    "sports/crashed-ice": "sports-crashed-ice",
    "sports/equestrian": "sports-equestrian",
    "sports/football/cfl": "sports-cfl",
    "sports/football/nfl": "sports-nfl",
    "sports/golf": "sports-golf",
    "sports/hockey/nhl": "sports-nhl",
    "sports/iwd": "sports-iwd-q",
    "sports/olympics": "sports-olympics",
    "sports/olympics/winter/alpine-skiing": "sports-alpine-skiing",
    "sports/olympics/summer/aquatics": "sports-aquatics",
    "sports/olympics/winter/curling": "sports-curling",
    "sports/olympics/summer/cycling": "sports-cycling",
    "sports/olympics/winter/figure-skating": "sports-figure-skating",
    "sports/olympics/winter/freestyle-skiing": "sports-freestyle-skiing",
    "sports/olympics/summer/gymnastics": "sports-gymnastics",
    "sports/olympics/promo": "sports-promo",
    "sports/olympics/winter/sliding": "sports-sliding",
    "sports/olympics/winter/snowboard": "sports-snowboard",
    "sports/olympics/winter/speed-skating": "sports-speedskating",
    "sports/olympics/summer/trackandfield": "sports-track-and-field",
    "sports/olympics/summer/volleyball": "sports-volleyball",
    "sports/olympics/summer/sports": "olympic-summer-sports-list",
    "sports/olympics/summer/highlights": "summer-olympics-highlights",
    "sports/paralympics": "sports-paralympics",
    "sports/paralympics/strip": "sports-paralympics-strip",
    "sports/podcasts": "sports-podcasts",
    "sports/podcasts/hnic": "sports-hnic-podcast",
    "sports/podcasts/players-own-voice": "players-own-voice-podcast",
    "sports/rugby": "sports-rugby",
    "sports/soccer": "sports-soccer",
    "sports/soccer/mls": "sports-soccer-mls",
    "sports/soccer/cpl": "sports-soccer-cpl",
    "sports/soccer/worldcup": "sports-soccer-worldcup",
    "sports/tennis": "sports-tennis",
    "sports/video": "sports-video",
    "sports/beingblackincanada": "being-black-in-canada-sports",
    television: "television",
    "television/fromthevaults": "tv-from-the-vaults",
    "television/arcticvets": "tv-artic-vets",
    "television/stillstanding": "tv-still-standing",
    "television/stillstanding/about": "tv-still-standing-about",
    "television/battleoftheblades": "tv-battle-of-the-blades",
    "television/battleoftheblades/skaters": "tv-battle-of-the-blades-skaters",
    "television/battleoftheblades/blades-performances": "tv-battle-of-the-blades-performances",
    "television/battleoftheblades/mini-blades": "tv-battle-of-the-blades-mini-blades",
    "television/watch": "television-watch",
    "television/familyfeud": "tv-family-feud",
    "television/higharctichaulers": "tv-high-arctic-haulers",
    "television/thedetectives": "tv-the-detectives",
    "television/higharctichaulers/ship": "tv-high-arctic-haulers-ship",
    "television/higharctichaulers/shore": "tv-high-arctic-haulers-shore",
    "television/whatreyouat": "tv-what-re-you-at",
    "television/anyonesgame": "anyones-game",
    "television/raceagainstthetide": "television-raceagainstthetide",
    visualstories: "",
};

export default LINEUP_SLUGS;
